import React from 'react';
import './Daily.css';
import moment from 'moment'
export const WeatherIcons = {
  "01d": "icons/sunny.svg",
  "01n": "icons/night.svg",
  "02d": "icons/day.svg",
  "02n": "icons/cloudy-night.svg",
  "03d": "icons/cloudy.svg",
  "03n": "icons/cloudy.svg",
  "50n": "icons/cloudy.svg",
  "04d": "icons/perfect-day.svg",
  "04n": "icons/cloudy-night.svg",
  "09d": "icons/rain.svg",
  "09n": "icons/rain-night.svg",
  "10d": "icons/rain.svg",
  "10n": "icons/rain-night.svg",
  "11d": "icons/storm.svg",
  "11n": "icons/storm.svg",
  "50d": "icons/rain.svg",
};

function Daily({data,icon,main}) {
    let setDayOfWeek = function (dayNum) {
  
        var weekday = new Array(7);
    
        
        var days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
        var d = new Date();
        var dayName = days[d.getDay()];
        var s=(d.getDay()+1+dayNum)%7;
        return days[s];
      };
    return (
      <>
       <h3>📅 DAILY FORECAST</h3>
      <div className="daily">
          {data?.daily?.slice(1).map((y,key)=>
          <div key={key} className="mydaily" >
           <div className="daily__days">
              <div className="daily_week_days">{setDayOfWeek(key)}</div>
              <div className="daily_days__date">{moment.unix(y.dt).format("ll")}</div>
              <div className="daily_days__icons">&nbsp;<img src={WeatherIcons[y.weather[0].icon]}/></div>
              <div className="daily_days__main">{y.weather[0].main}</div>
              <div className="daily_days_temp"><span>{Math.round(y.temp.day)}°C</span>&nbsp;&nbsp;|&nbsp;&nbsp;{main}</div>
           </div>
         </div>)}
         
          
          
          {/* {console.log(data.daily)} */}
      </div>
        </>
    );
}

export default Daily;